export default __webpack_public_path__ + "static/media/test-suite-sample-2.4d1da12c.png";